const key = "jamesify-forms-names";

const applicable = (resp) => resp.config.url.endsWith("api/forms");

const modify = (resp) => {
	resp.data.Data.forEach(form => form.Name += " jamesified");
};

export const jamesifyForm = [key, applicable, modify];